import * as React from 'react'
import * as URLS from 'modules/urls'
import { useApp } from '@pareto-engineering/design-system'
import { USE_CASE_PATHS, OPS_SOLUTION_PATHS } from 'modules/solutions/solutionUrls'

export const defaultNavigationItems = [
  {
    name:'Blog',
    link:URLS.BLOG.HOME,
  },
  {
    name:'Apply to train AI',
    link:URLS.SITE.AI_TRAINER,
  },
  {
    name:'Join our team',
    link:URLS.SITE.CAREERS,
  },
]

export const defaultUseCaseItems = [
  {
    name:'RLHF',
    link:USE_CASE_PATHS.RLHF,
  },
  {
    name:'Side by side RL',
    link:USE_CASE_PATHS.SIDE_BY_SIDE_RL,
  },
  {
    name:'Original content',
    link:USE_CASE_PATHS.ORIGINAL_CONTENT,
  },
  {
    name:'Creative hallucination',
    link:USE_CASE_PATHS.CREATIVE_HALLUCINATION,
  },
  {
    name:'Safety, ethics, & compliance',
    link:USE_CASE_PATHS.SAFETY_ETHICS_COMPLIANCE,
  },
  {
    name:'Honesty and factuality training',
    link:USE_CASE_PATHS.HONESTY_FACTUALITY_TRAINING,
  },
  {
    name:'LLM prompting',
    link:USE_CASE_PATHS.LLM_PROMPTING,
  },
  {
    name:'Data classification & indexing',
    link:USE_CASE_PATHS.CLASSIFICATION,
  },
  {
    name:'Engine annotation',
    link:USE_CASE_PATHS.ENGINE_ANNOTATION,
  },
  {
    name:'LLM fluency and relevancy grading',
    link:USE_CASE_PATHS.LLM_FLUENCY_RELEVANCY_GRADING,
  },
  {
    name:'Chain-of-thought reasoning',
    link:USE_CASE_PATHS.CHAIN_OF_THOUGHT_REASONING,
  },
]

export const defaultOpsServiceItems = [
  {
    name:'Outsourced ops assistants',
    link:URLS.SITE.OPS_HOME,
  },
  {
    name:'How it works',
    link:URLS.SITE.HOW_IT_WORKS,
  },
  {
    name:'Explore ops solutions',
    link:OPS_SOLUTION_PATHS.LIST,
  },
]

export const defaultPrivacyItems = [
  {
    name     :'Code of conduct',
    Component:(() => {
      const config = useApp()

      return (
        <a
          href={config.EXTRA.CODE_OF_CONDUCT}
          target="_blank"
          rel="noopener noreferrer"
        >
          Code of conduct
        </a>
      )
    }),
  },
  {
    name:'Privacy policy',
    link:URLS.STATIC.PRIVACY,
  },
  {
    name:'Terms',
    link:URLS.STATIC.TERMS,
  },
  {
    name:'Cookies',
    link:URLS.STATIC.COOKIES,
  },
]

export const defaultSocialItems = ['facebook', 'twitter', 'instagram', 'linkedin', 'threads']
